if (!customElements.get('testimonial-carousel')) {
    class Testimonials extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.elements = {
                slider: this.querySelector('[id^="Slider-"]'),
                prevButton: this.querySelector('.slider-button--prev'),
                nextButton: this.querySelector('.slider-button--next'),
                pagination: this.querySelector('.swiper-pagination')
            };

            if (!this.elements.slider || (this.dataset.layout != "slider" && this.dataset.mobileLayout != "slider")) return;

            const style = window.getComputedStyle(this.elements.slider);
            const desktopSpacing = Number(parseInt(style.getPropertyValue('--desktop-horizontal-spacing').trim()));
            const mobileSpacing = Number(parseInt(style.getPropertyValue('--mobile-horizontal-spacing').trim()));

            this.settings = {
                enableDesktop: this.dataset.layout == "slider",
                enableMobile: this.dataset.mobileLayout == "slider",
                desktopItems: this.dataset.columns,
                mobileItems: this.dataset.mobileColumns,
                spacingDesktop: desktopSpacing || 0,
                spacingMoblie: mobileSpacing || 0,
                loop: this.dataset.loop === "true",
                autoplay: this.dataset.autoplay === "true",
                autoplaySpeed: this.dataset.autoplaySpeed ? this.dataset.autoplaySpeed * 1000 : 3000,
                arrowCenterimage: this.dataset.arrowCenterimage || 0
            };

            this.sectionId = this.dataset.sectionId;
            this.sliderInstance = false;

            this.init();
        }

        init() {
            this.load();
            window.addEventListener('resize', this.load.bind(this));
        }

        load() {
            // const shouldEnable = themeVariables.config.mqlMedium ? this.settings.enableMobile : this.settings.enableDesktop;
            const shouldEnable = window.innerWidth >= 990  ? this.settings.enableDesktop : this.settings.enableMobile; 


            if (shouldEnable && !this.sliderInstance) {
                this.initSlider();
            } else if (!shouldEnable && this.sliderInstance) {
                this.destroySlider();
            }
        }

        initSlider() {
            // const additionalModules = [
            //     Theme.Swiper.Autoplay
            // ];
            
            this.sliderOptions = {
                slidesPerView: this.settings.mobileItems,
                spaceBetween: this.settings.spacingMoblie,
                loop: this.settings.loop,
                navigation: {
                    nextEl: this.elements.nextButton,
                    prevEl: this.elements.prevButton
                },
                breakpoints: {
                    989: {
                        slidesPerView: this.settings.desktopItems,
                        spaceBetween: this.settings.spacingDesktop
                    }
                },
                on: {
                    init: this.handleAfterInit.bind(this),
                    resize: this.handleResize.bind(this)
                },
                threshold: 2
            };

            if (this.elements.pagination) {
                this.sliderOptions.pagination = {
                    el: this.elements.pagination,
                    clickable: true
                };
            }

            const autoplayDelay = parseInt(this.settings.autoplaySpeed);
            if (this.settings.autoplay && autoplayDelay > 0) {
                this.sliderOptions = {
                    ...this.sliderOptions,
                    autoplay: {
                        delay: autoplayDelay,
                        disableOnInteraction: false
                    }
                };
            }

            if (typeof this.sliderInstance !== "object") {
                // this.sliderInstance = new themeVariables.Carousel(this.elements.slider, this.sliderOptions, additionalModules);
                this.sliderInstance = new Swiper(this.elements.slider, this.sliderOptions);
                this.sliderInstance.init();
            }

            if (Shopify.designMode && typeof this.sliderInstance === "object") {
                document.addEventListener("shopify:block:select", (e) => {
                    if (e.detail.sectionId !== this.sectionId) return;

                    const { target } = e;
                    const index = Number(target.dataset.index);
                    this.sliderInstance.slider.slideToLoop(index);
                });
            }
        }

        handleAfterInit() {
            if (this.settings.arrowCenterimage) {
                this.setNavigationPosition();
            }
        }

        handleResize() {
            if (this.settings.arrowCenterimage) {
                this.setNavigationPosition();
            }
        }

        setNavigationPosition() {
            var items_slide = this.querySelectorAll(
                ".media-wrapper"
            );
            if (items_slide.length != 0) {
                var oH = [];
                items_slide.forEach((e) => {
                    oH.push(e.offsetHeight / 2);
                });
                var max = Math.max(...oH);
                var arrowsOffset = "--arrows-offset-top: " + max + "px";
                if (this.querySelectorAll(".slider-button")) {
                    this.querySelectorAll(".slider-button").forEach((arrow) => {
                        arrow.setAttribute("style", arrowsOffset);
                    });
                }
            }
        }

        destroySlider() {
            if (typeof this.sliderInstance === "object") {
                this.sliderInstance.slider.destroy();
                this.sliderInstance = false;
            }
        }
    }
    customElements.define("testimonial-carousel", Testimonials);
}